import API from "../../../api/axiosClient";

 

const baseUrl = "AppSettings";

export const getMaxGroups = async () => {
    const response = await API.get(
        `${baseUrl}/max-groups`
    );

    return response.data;
};

export const updateMaxGroups = async (
    maxGroupsPerUser: number
) => {
    await API.put(
        `${baseUrl}/max-groups`,
        {
            maxGroupsPerUser
        }
    );
};